import API from "../api/apiAdmin";

export const AdminDashboardService = {
    getDashboardStats: async () => {
        try {
            const response = await API.get("/admin/dashboard");
            return response.data;
        } catch (error) {
            console.error("Error fetching admin dashboard stats:", error);
            throw error;
        }
    }
};
